import { t } from "@lingui/macro";

import { HoleCount } from "@whoosh/design-system/src/components/icons_v2/courseLayout";

export const getHoleCountString = (count: HoleCount): string => {
  switch (count) {
    case "NINE":
      return t`Nine (9)`;
    case "EIGHTEEN":
      return t`Eighteen (18)`;
    default:
      return t`None`;
  }
};
